import React from 'react';
import { observer } from "mobx-react-lite";
import { useTranslation } from 'react-i18next';
import { DisplayMode, TranslatedStringActionDetail } from './components/TranslatedStringActionDetail';
import { ActionEditorChangeGroup, groupUndoableActionEditorChanges } from '../../../stores/undo/operation/ActionEditorSubmitChangesOp';
import { QuestSelectionDetail } from './components/QuestSelectionDetail';
import { Dropdown } from '../../editor/Dropdown';
import { isBlank } from "../../../../shared/helper/generalHelpers";
import { getActionShortDescriptionForActionEditor } from '../../../helper/actionEditorHelpers';
import { ElementGroup } from './components/BaseElements';
import { actionEditorStore } from '../../../stores/ActionEditorStore';
export const QuestOrTaskActionDetail = observer(({
  parentTree,
  questId,
  questIdSetter,
  taskId,
  taskIdSetter,
  text
}) => {
  const {
    t
  } = useTranslation();
  const {
    currentRootActionTree
  } = actionEditorStore;
  const tasks = !taskIdSetter ? null : currentRootActionTree.tasks(questId);

  const setQuestAndResetTask = questId => {
    groupUndoableActionEditorChanges(ActionEditorChangeGroup.UnspecificGroupedNodeChanges, () => {
      questIdSetter(questId);
      if (taskIdSetter) taskIdSetter("");
    });
  };

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(QuestSelectionDetail, {
    parentTree: parentTree,
    name: t(tasks ? "action_editor.property_task" : "action_editor.property_quest"),
    questId: questId,
    questIdSetter: setQuestAndResetTask
  }), tasks && /*#__PURE__*/React.createElement(ElementGroup, null, /*#__PURE__*/React.createElement(Dropdown, {
    className: isBlank(taskId) ? "invalid" : "",
    value: taskId,
    onChange: ({
      target
    }) => taskIdSetter(target.value)
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }), [...tasks].map(task => /*#__PURE__*/React.createElement("option", {
    key: task.$modelId,
    value: task.$modelId
  }, getActionShortDescriptionForActionEditor(task, t))))), /*#__PURE__*/React.createElement(TranslatedStringActionDetail, {
    name: t("action_editor.property_description"),
    translatedString: text,
    displayMode: DisplayMode.CommentAndGenders,
    allowBlankValue: false
  }));
});